<div class="wrapper">
  <h2>Профиль производителя № {{ _manufacturer?.id }}</h2>
  <form [formGroup]="profileForm" (ngSubmit)="save()" class="drop-padding">
    <mat-form-field appearance="outline">
      <mat-label>Наименование</mat-label>
      <input matInput type="text" formControlName="description" />
    </mat-form-field>
    <button mat-flat-button color="primary" type="submit">Сохранить</button>
    <button mat-flat-button color="warn" type="button" (click)="openConfirmDialog()">
      Удалить
    </button>
  </form>
</div>
